import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { helpers, normalizedTrackingStatus, Text } from '@reveni-io/reveni-ui'

import { getDateByStatus } from '@/LabelTrackingPage/helpers'

import { getStyleOptionsByTypeAndStatus } from './helpers'
import * as Styles from './styles'

const SubStatus = ({ info }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const styleOptions = getStyleOptionsByTypeAndStatus(info?.type, info?.status, info?.is_alert, theme)
  const message = t(normalizedTrackingStatus?.[info?.normalized_tracking_status])

  if (!message) return null

  return (
    <Styles.Container backgroundColor={styleOptions?.backgroundColor}>
      <Text type="bodyXSRegular" color={theme.colors.grey.tone500} customStyles={{ textTransform: 'uppercase' }}>
        {t('Última actualización')}
      </Text>
      <Styles.StatusMessageContainer>
        <Text type="bodyMBold" color={styleOptions?.color}>
          &quot;{message}&quot;
        </Text>
        <Text type="bodyXSRegular" color={theme.colors.grey.tone500}>
          {helpers.getRelativeTime(getDateByStatus(info, info.status), t)}
        </Text>
      </Styles.StatusMessageContainer>
    </Styles.Container>
  )
}

export default SubStatus
